// extracted by mini-css-extract-plugin
export default {"error":"styles_error__Zp2Gx","product":"styles_product__n14H2","value":"styles_value__OruHy","description":"styles_description__O2OR1"};